/** @format */

import template from './gb-below-reserve-badge.html';
import './gb-below-reserve-badge.scss';

export const GbBelowReserveBadgeComponent = {
    template,
    require: {
        gbApp: '^^',
        gbWidget: '^^',
    },
    bindings: {
        biddingItem: '<',
        winningBid: '<?',
    },
    controller: class GbBelowReserveBadgeComponent {
        constructor($ccColors) {
            'ngInject';

            this.primaryStyles = {};
            this.$ccColors = $ccColors;
            this.colorMap = {};

            this.amountContainerWidth = 0;
        }

        $onInit() {
            this.colorMap = {
                compact_table: this.gbWidget.widget.table_accent_color,
                tall_card: this.gbWidget.widget.table_primary_color,
                standard_table: this.gbWidget.widget.table_primary_color,
            };

            const amountContainerElement = document.getElementsByClassName('amount-container');

            const secondaryAreaElement = document.getElementsByClassName('below-reserve-container');

            if (amountContainerElement.length > 0) {
                this.amountContainerWidth = amountContainerElement[0].offsetWidth;
            } else if (secondaryAreaElement.length > 0) {
                this.amountContainerWidth = secondaryAreaElement[0].offsetWidth;
            }
        }
        shouldShowBelowReserve() {
            return (
                this.biddingItem &&
                this.biddingItem.reserve_price_enabled &&
                this.winningBid &&
                this.winningBid.amount < this.biddingItem.reserve_price
            );
        }

        getBelowReserveStyle() {
            let fontMultiplier = 0.05;
            if (!this.biddingItem.hide_reserve_price) {
                fontMultiplier = 0.04;
            }
            let fontSize = (this.amountContainerWidth * fontMultiplier) | 0;

            if (fontSize > 14) {
                fontSize = 14;
            }

            return {
                'font-size': `${fontSize}px`,
            };
        }

        getReserveAmount() {
            if (!this.biddingItem) {
                return undefined;
            }

            if (this.biddingItem.hide_reserve_price) {
                return undefined;
            }
            return `${this.gbApp.getCurrencySymbol()}${this.biddingItem.reserve_price}`;
        }
    },
};
